module.exports = __webpack_public_path__ + "img/girdRequest-2.c37c002e.png";